import { SECTION_IDS } from '../../../core/constants/navigation';
import { SITE_SLOGAN } from '../../../core/constants/seo';
import Reveal from '../../../common/components/Reveal/Reveal';
import ResponsiveImage from '../../../common/components/ResponsiveImage/ResponsiveImage';
import SectionHeading from '../../../common/components/SectionHeading/SectionHeading';
import { IconHeart, IconShield, IconZap } from '../../../common/icons';

import '../styles/about.css';

const VALUES = [
    {
        title: 'Cercana y colaborativa',
        text: 'Te guiamos y acompañamos en cada paso. Tu proyecto se construye con tu equipo, no a sus espaldas.',
        Icon: IconHeart,
    },
    {
        title: 'Creativa y dinámica',
        text: 'Proponemos ideas frescas, piezas audiovisuales de alto impacto y diseño interactivo.',
        Icon: IconZap,
    },
    {
        title: 'Profesional y tecnológica',
        text: 'Garantizamos estándares técnicos sólidos en plataformas digitales y medios masivos.',
        Icon: IconShield,
    },
];

export default function About() {
    return (
        <section id={SECTION_IDS.ABOUT} className="about" aria-labelledby="about-title">
            <div className="about__inner layout-container">
                <Reveal className="about__visual">
                    <div className="about__frame">
                        <ResponsiveImage
                            name="about-team"
                            sizes="(min-width: 1024px) 480px, (min-width: 640px) 70vw, 92vw"
                            width={1200}
                            height={1500}
                            className="about__image"
                            alt="Dos profesionales celebrando un logro de trabajo con un choque de manos"
                        />
                    </div>
                    <blockquote className="about__quote">
                        <p>{SITE_SLOGAN}</p>
                        <cite>Nuestra promesa de valor</cite>
                    </blockquote>
                </Reveal>

                <div className="about__content">
                    <SectionHeading
                        headingId="about-title"
                        eyebrow="Nosotros"
                        title="Un aliado cercano para que tu medio crezca"
                        lead="Total Medios es una firma de asesoría integral, acompañamiento estratégico, marketing digital, producción audiovisual y desarrollo web. Reunimos en un solo equipo lo que un medio necesita para competir en el ecosistema digital."
                    />
                    <ul className="about__values">
                        {VALUES.map(({ title, text, Icon }, index) => (
                            <Reveal as="li" key={title} delay={index * 100} className="about__value">
                                <span className="about__value-icon"><Icon /></span>
                                <div>
                                    <h3 className="about__value-title">{title}</h3>
                                    <p className="about__value-text">{text}</p>
                                </div>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
